export enum GEO_MODULE_ERROR {
    UNKNOWN = 'UNKNOWN',
    NO_GEOLOCATION_IN_DEVICE = 'NO_GEOLOCATION_IN_DEVICE',
    PERMISSION_DENIED = 'PERMISSION_DENIED',
    POSITION_UNAVAILABLE = 'POSITION_UNAVAILABLE',
    TIMEOUT = 'TIMEOUT',
}
